module.exports = __webpack_public_path__ + "static/media/FutebolFlix.a24c25cc.png";